export default __webpack_public_path__ + "static/media/task6confirmed.e74e1714.png";